import _asyncToGenerator from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { createInstance, setLogger } from '@optimizely/optimizely-sdk';
import { PELOTON_PLATFORM, ENVIRONMENT, isProdEnv } from '@webtv/env';
var CACHED_USER_ID_KEY = 'cachedAnalyticsUserId';
var isProd = isProdEnv(ENVIRONMENT);
export var ExperimentState = /*#__PURE__*/function () {
  function ExperimentState() {
    _classCallCheck(this, ExperimentState);

    _defineProperty(this, "userId", void 0);

    _defineProperty(this, "memberGroups", void 0);

    _defineProperty(this, "baseAttributes", void 0);

    _defineProperty(this, "optimizelyClient", void 0);
  }

  _createClass(ExperimentState, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setAttributes({
                  platform: PELOTON_PLATFORM
                }); // Wait for Segment and Optimizely

                _context.next = 3;
                return Promise.all([this.isSegmentReady(), this.isOptimizelyReady()]);

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "isSegmentReady",
    value: function () {
      var _isSegmentReady = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        var hasLoadedOrAborted;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                hasLoadedOrAborted = false;
                return _context2.abrupt("return", new Promise(function (resolve) {
                  if (typeof analytics === 'undefined') resolve(false);
                  analytics.ready(function () {
                    hasLoadedOrAborted = true;

                    _this.setUserId();

                    resolve(true);
                  }); // Segment doesn't provide a method for detecing when `.ready` calls fail
                  // In practice .ready should be nearly synchronous in almost all situations so aborting after 5 seconds feels like a safe default

                  if (!hasLoadedOrAborted) {
                    window.setTimeout(function () {
                      if (!hasLoadedOrAborted) {
                        resolve(true);
                        hasLoadedOrAborted = true;
                      }
                    }, 5000);
                  }
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function isSegmentReady() {
        return _isSegmentReady.apply(this, arguments);
      }

      return isSegmentReady;
    }()
  }, {
    key: "isOptimizelyReady",
    value: function () {
      var _isOptimizelyReady = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new Promise(function (resolve) {
                  var _window;

                  if (typeof window === 'undefined') resolve(false); // optimizelySdk.setLogLevel can't disable logging completely

                  if (isProd) {
                    setLogger(null);
                  } // https://docs.developers.optimizely.com/full-stack/docs/javascript-client-side-implementation#section-datafile-management-for-javascript-client-side-implementation


                  var client = createInstance({
                    datafile: (_window = window) === null || _window === void 0 ? void 0 : _window.optimizelyDatafile,
                    // default parameters, prevents console warnings
                    eventBatchSize: 10,
                    eventFlushInterval: 1000
                  });

                  _this2.setOptimizelyClient(client);

                  _this2.optimizelyClient.onReady({
                    timeout: 5000
                  }).then(function () {
                    resolve(true);
                  });
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function isOptimizelyReady() {
        return _isOptimizelyReady.apply(this, arguments);
      }

      return isOptimizelyReady;
    }()
  }, {
    key: "setProperties",
    value: function setProperties(user) {
      var _user$memberGroups;

      this.setMemberGroups((_user$memberGroups = user === null || user === void 0 ? void 0 : user.memberGroups) !== null && _user$memberGroups !== void 0 ? _user$memberGroups : []);
    }
  }, {
    key: "setUserId",
    value: function setUserId() {
      // Ensure user id for analytics persists between sessions
      var maybeCachedUserId = window.localStorage.getItem(CACHED_USER_ID_KEY);

      if (typeof maybeCachedUserId === 'string' && maybeCachedUserId.length > 0) {
        this.userId = maybeCachedUserId;
      } else {
        var _analytics, _analytics$user;

        if (typeof analytics === 'undefined') return;
        var newId = (_analytics = analytics) === null || _analytics === void 0 ? void 0 : (_analytics$user = _analytics.user()) === null || _analytics$user === void 0 ? void 0 : _analytics$user.anonymousId();
        window.localStorage.setItem(CACHED_USER_ID_KEY, newId);
        this.userId = newId;
      }
    }
  }, {
    key: "getUserId",
    value: function getUserId() {
      return this.userId;
    }
  }, {
    key: "setMemberGroups",
    value: function setMemberGroups(groups) {
      var newGroups = groups.reduce(function (acc, group) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, group, true));
      }, {});
      this.memberGroups = _objectSpread(_objectSpread({}, this.memberGroups), newGroups);
    }
  }, {
    key: "setAttributes",
    value: function setAttributes(attribute) {
      this.baseAttributes = _objectSpread(_objectSpread({}, this.baseAttributes), attribute);
    }
  }, {
    key: "getBaseAttributes",
    value: function getBaseAttributes() {
      return this.baseAttributes;
    }
  }, {
    key: "getMemberGroups",
    value: function getMemberGroups() {
      return this.memberGroups;
    }
  }, {
    key: "getCombinedAttributes",
    value: function getCombinedAttributes() {
      var customAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _objectSpread(_objectSpread(_objectSpread({}, customAttributes), this.getBaseAttributes()), this.getMemberGroups());
    }
  }, {
    key: "setOptimizelyClient",
    value: function setOptimizelyClient(client) {
      this.optimizelyClient = client;
    }
  }, {
    key: "getOptimizelyClient",
    value: function getOptimizelyClient() {
      return this.optimizelyClient;
    }
  }]);

  return ExperimentState;
}();
export var ExperimentManager = new ExperimentState();